
import LedSearchFormLicencePlate from '@/components/LedSearchFormLicencePlate.vue'
import LedSearchFormVehicles from '@/components/LedSearchFormVehicles.vue'
import VehicleSelectionModal from '@/components/VehicleSelectionModal.vue'
import licencePlateMixin from '@/mixins/licencePlateMixin'
import vehicleSelectionTargetMixin from '@/mixins/vehicleSelectionTargetMixin'

export default {
  name: 'VehiclesSelectorSidebar',

  components: {
    LedSearchFormLicencePlate,
    LedSearchFormVehicles,
    VehicleSelectionModal,
  },

  mixins: [licencePlateMixin, vehicleSelectionTargetMixin],

  data() {
    return {
      selectedCountry: 'FR',
      showAllHistory: false,
      historyDisplayLimit: 3,
      vehiclesList: [],
      currentPlate: null,
      keepSelectionTarget: false,
    }
  },

  computed: {
    searchHistory() {
      return this.$store.getters.vehicle_search_history
    },

    displayedHistory() {
      if (
        this.showAllHistory ||
        this.searchHistory.length <= this.historyDisplayLimit
      ) {
        return this.searchHistory
      }
      return this.searchHistory.slice(0, this.historyDisplayLimit)
    },

    hasMoreHistory() {
      return this.searchHistory.length > this.historyDisplayLimit
    },
  },

  mounted() {
    this.selectedCountry = this.currentCountryCode
  },

  methods: {
    closeSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-vehicle-selector')
    },

    onDrawerShown() {
      this.showAllHistory = false
      this.keepSelectionTarget = false
      if (this.$store.state.auth?.loggedIn) {
        this.$store.dispatch('loadVehicleSearchHistory')
      }
    },

    onDrawerHidden() {
      this.showAllHistory = false
      if (!this.keepSelectionTarget) {
        this.clearVehicleSelectionTarget()
      }
      this.keepSelectionTarget = false
    },

    onVehicleSelectedFromForm(vehicle) {
      this.$store.dispatch('setSelectedVehicle', vehicle)
      this.$store.dispatch('addToVehicleSearchHistory', vehicle)
      this.closeSidebar()
    },

    onVehicleFromPlateSelected(vehicle) {
      this.$store.dispatch('setSelectedVehicle', vehicle)
      this.$store.dispatch('addToVehicleSearchHistory', vehicle)
    },

    selectVehicleFromHistory(vehicle) {
      this.$store.dispatch('setSelectedVehicle', vehicle)

      if (this.consumeVehicleSelectionTarget(vehicle)) {
        this.closeSidebar()
        return
      }

      this.$router.push(
        this.localePath({
          name: 'recherche-led-accessoires-brand-type-typeid',
          params: {
            brand: this.$slugify(vehicle.brand.name).toLowerCase(),
            type: this.$slugify(vehicle.name).toLowerCase(),
            typeid: vehicle.id,
          },
        })
      )

      this.closeSidebar()
    },

    removeFromHistory(vehicleId, search) {
      this.$store.dispatch('removeFromVehicleSearchHistory', {
        vehicleId,
        search,
      })
    },

    clearHistory() {
      this.$store.dispatch('clearVehicleSearchHistory')
    },

    onMultipleVehiclesFound({ vehicles, plate }) {
      this.vehiclesList = vehicles
      this.currentPlate = plate
      this.keepSelectionTarget = true
      this.closeSidebar()
      this.$nextTick(() => {
        this.$refs.vehicleSelectionModal.show()
      })
    },
  },
}
